module.exports = __webpack_public_path__ + "resources/img/bg_solution_main2_v2.f5215df966a6fa051ffad40340d271b2.png";